const validateIsAllowed = (isAllowed) => !(isAllowed != null && typeof isAllowed !== 'function' && typeof isAllowed !== 'boolean');
const isStringOrStrings = (value) => {
    if (Array.isArray(value)) {
        return value.every(item => typeof item === 'string');
    }
    return typeof value === 'string';
};
const isRegExp = (value) => {
    return Object.prototype.toString.call(value) === '[object RegExp]';
};
export const SPARKY_LIBS_EXTPOINT = {
    id: 'sparky.internal.libs.global',
    version: '0.0.1',
    compatibilityRange: '~0.0.1',
    isSingleton: false,
    description: 'inject libs to global sparky libs namespace',
    validator: {
        validate(config) {
            const pass = (typeof config === 'function') ||
                (typeof config === 'object' && Object.keys(config).length > 0) ||
                ((config === null || config === void 0 ? void 0 : config.default) && Object.keys(config.default).length > 0);
            return {
                success: pass,
                error: pass ? undefined : 'libs must be a non-empty object or a function that returns a non-empty object',
            };
        }
    }
};
export const SPARKY_MFE_TSG_VERSION_SELECT_EXTPOINT = {
    id: 'sparky.mfe.tsg.versions.select',
    version: '0.0.1',
    compatibilityRange: '~0.0.1',
    isSingleton: false,
    description: 'specify micro-app version or disable all versions',
    validator: {
        validate(config) {
            if (typeof config.name !== 'string') {
                return {
                    success: false,
                    error: 'name of the micro-app must be a string',
                };
            }
            if (typeof config.select !== 'function') {
                return {
                    success: false,
                    error: 'select must be a function',
                };
            }
            if (!validateIsAllowed(config.isAllowed)) {
                return {
                    success: false,
                    error: 'optional isAllowed must be a function',
                };
            }
            return {
                success: true,
            };
        }
    }
};
export const SPARKY_MFE_TSG_PREFILTER_EXTPOINT = {
    id: 'sparky.mfe.tsg.mfe.prefilter',
    version: '0.0.1',
    compatibilityRange: '~0.0.1',
    isSingleton: false,
    description: 'filter micro-app versions before run the version select',
    validator: {
        validate(config) {
            if (config.names && !isStringOrStrings(config.names)) {
                return {
                    success: false,
                    error: 'name of the micro-app must be a string',
                };
            }
            if (typeof config.filter !== 'function') {
                return {
                    success: false,
                    error: 'select must be a function',
                };
            }
            if (!validateIsAllowed(config.isAllowed)) {
                return {
                    success: false,
                    error: 'optional isAllowed must be a function',
                };
            }
            return {
                success: true,
            };
        }
    }
};
const navRouteValidator = {
    validate(config) {
        if (!config) {
            return {
                success: false,
                error: 'route configuration cannot be empty',
            };
        }
        if (typeof config.path !== 'string') {
            return {
                success: false,
                error: 'path must be a string and required',
            };
        }
        if (typeof config.component !== 'function') {
            return {
                success: false,
                error: 'component must be a function or class/function ReactComponent and required',
            };
        }
        if (config.contentClassName && typeof config.contentClassName !== 'string') {
            return {
                success: false,
                error: 'optional contentClassName must be a string',
            };
        }
        if (config.mapStateToProps && typeof config.mapStateToProps !== 'function') {
            return {
                success: false,
                error: 'optional mapStateToProps must be a function',
            };
        }
        if (config.stateLoaders && !isStringOrStrings(config.stateLoaders)) {
            return {
                success: false,
                error: 'optional stateLoaders must be an array of strings',
            };
        }
        if (!validateIsAllowed(config.isAllowed)) {
            return {
                success: false,
                error: 'optional isAllowed must be a function',
            };
        }
        if (config.fallbackRedirect && typeof config.fallbackRedirect !== 'string' && typeof config.fallbackRedirect !== 'function') {
            return {
                success: false,
                error: 'optional fallbackRedirect must be a string or a function',
            };
        }
        if (config.replacePaths && !isStringOrStrings(config.replacePaths)) {
            return {
                success: false,
                error: 'optional replacePaths must be a string or an array of strings',
            };
        }
        if (config.flags && typeof config.flags !== 'object') {
            return {
                success: false,
                error: 'optional flags must be an object',
            };
        }
        return {
            success: true,
        };
    }
};
export const SPARKY_NAV2_ROUTES_EXTPOINT = {
    id: 'sparky.nav.v2.routes',
    version: '0.0.1',
    compatibilityRange: '~0.0.1',
    isSingleton: false,
    description: 'add routes to sparky for nav v2',
    validator: navRouteValidator,
};
export const SPARKY_NAV3_ROUTES_EXTPOINT = {
    id: 'sparky.nav.v3.routes',
    version: '0.0.1',
    compatibilityRange: '~0.0.1',
    isSingleton: false,
    description: 'add routes to sparky for nav v3',
    validator: navRouteValidator,
};
const navRouteRedirectValidator = {
    validate(config) {
        if (!config) {
            return {
                success: false,
                error: 'redirect configuration cannot be empty',
            };
        }
        if (typeof config.path !== 'string') {
            return {
                success: false,
                error: 'path must be a string and required',
            };
        }
        if (typeof config.redirectTo !== 'string') {
            return {
                success: false,
                error: 'redirectTo must be a string and required',
            };
        }
        if (config.push != null && typeof config.push !== 'boolean') {
            return {
                success: false,
                error: 'optional push must be a boolean',
            };
        }
        if (config.exact != null && typeof config.exact !== 'boolean') {
            return {
                success: false,
                error: 'optional exact must be a boolean',
            };
        }
        if (config.preserveSearch != null && typeof config.preserveSearch !== 'boolean') {
            return {
                success: false,
                error: 'optional preserveSearch must be a boolean',
            };
        }
        if (!validateIsAllowed(config.isAllowed)) {
            return {
                success: false,
                error: 'optional isAllowed must be a function',
            };
        }
        return {
            success: true,
        };
    }
};
export const SPARKY_NAV3_REDIRECTS_EXTPOINT = {
    id: 'sparky.nav.v3.redirects',
    version: '0.0.1',
    compatibilityRange: '~0.0.1',
    isSingleton: false,
    description: 'add redirect route to sparky for nav v3',
    validator: navRouteRedirectValidator,
};
export const leftNavValidtor = {
    validate(config) {
        if (!config) {
            return {
                success: false,
                error: 'top left nav configuration cannot be empty',
            };
        }
        if (typeof config.navigation !== 'function') {
            return {
                success: false,
                error: 'navigation must be a function and required',
            };
        }
        if (!validateIsAllowed(config.isAllowed)) {
            return {
                success: false,
                error: 'optional isAllowed must be a function',
            };
        }
        return {
            success: true,
        };
    }
};
export const SPARKY_NAV3_LEFT_NAV_EXTPOINT = {
    id: 'sparky.nav.v3.left.items',
    version: '0.0.1',
    compatibilityRange: '~0.0.1',
    isSingleton: false,
    description: 'merge navigation tree to sparky for left nav v3',
    validator: leftNavValidtor,
};
export const SPARKY_NAV3_LEFT_NAV_TPL_EXTPOINT = {
    id: 'sparky.nav.v3.left.tpl',
    version: '0.0.1',
    compatibilityRange: '~0.0.1',
    isSingleton: true,
    description: 'template for navigation tree to sparky for left nav v3',
    validator: leftNavValidtor,
};
const validateLeftNavBase = (config) => {
    if (!config) {
        return {
            success: false,
            error: 'top left nav configuration cannot be empty',
        };
    }
    if (!config.key && !config.path) {
        return {
            success: false,
            error: 'either key or path is required for a left nav item'
        };
    }
    if (config.key && typeof config.key !== 'string') {
        return {
            success: false,
            error: 'key must be a string if provided'
        };
    }
    if (config.path && typeof config.path !== 'string') {
        return {
            success: false,
            error: 'path must be a string if provided'
        };
    }
    if (!config.title || (typeof config.title !== 'string' && typeof config.title !== 'function')) {
        return {
            success: false,
            error: 'title must be a string or a function and required'
        };
    }
    if (config.disabled != null && typeof config.disabled !== 'boolean' && typeof config.disabled !== 'function') {
        return {
            success: false,
            error: 'disabled must be a boolean or a function return boolean'
        };
    }
    if (config.avail != null && typeof config.avail !== 'function') {
        return {
            success: false,
            error: 'avail must be a function return boolean'
        };
    }
    if (config.badge && typeof config.badge !== 'function') {
        return {
            success: false,
            error: 'badge must be a function returning NavBadgeProps or undefined'
        };
    }
    if (config.component) {
        return {
            success: false,
            error: 'component is not allowed in dynamic left nav item'
        };
    }
};
const validateDirectLeftNavCommon = (config) => {
    if (!config) {
        return {
            success: false,
            error: 'top left nav configuration cannot be empty',
        };
    }
    const result = validateLeftNavBase(config);
    if (result) {
        return result;
    }
    if (config.stateLoaders && !isStringOrStrings(config.stateLoaders)) {
        return {
            success: false,
            error: 'optional stateLoaders must be an array of strings',
        };
    }
    if (!validateIsAllowed(config.isAllowed)) {
        return {
            success: false,
            error: 'optional isAllowed must be a function',
        };
    }
};
export const SPARKY_NAV3_DYNAMIC_TOP_LEFT_EXTPOINT = {
    id: 'sparky.nav.v3.dynamic.left.top',
    version: '0.0.1',
    compatibilityRange: '~0.0.1',
    isSingleton: false,
    description: 'merge navigation dynamic sub-menu to sparky for bottom left nav v3',
    validator: {
        validate(config) {
            const baseResult = validateDirectLeftNavCommon(config);
            if (baseResult) {
                return baseResult;
            }
            const traverse = (item) => {
                const result = validateLeftNavBase(item);
                if (result) {
                    return result;
                }
                if (item.dynamicChildren && typeof item.dynamicChildren !== 'function') {
                    return {
                        success: false,
                        error: 'dynamicChildren must be a function return an array of left nav item'
                    };
                }
                if (item.children) {
                    if (!Array.isArray(item.children) || item.children.length !== 1) {
                        return {
                            success: false,
                            error: 'children must be an array with exactly one item for a dynamic left nav item'
                        };
                    }
                    if (item.dynamicChildren) {
                        return {
                            success: false,
                            error: 'dynamicChildren and children cannot be used together for a dynamic left nav item'
                        };
                    }
                    const result = traverse(item.children[0]);
                    if (result) {
                        return result;
                    }
                }
                if (!item.children && !item.dynamicChildren) {
                    return {
                        success: false,
                        error: 'either dynamicChildren or children is required for a dynamic left nav item'
                    };
                }
                if (item.navComponent) {
                    return {
                        success: false,
                        error: 'navComponent is not allowed for dynamic left nav item',
                    };
                }
                if (item.mapStateToProps) {
                    return {
                        success: false,
                        error: 'mapStateToProps is not allowed',
                    };
                }
            };
            const traverseResult = traverse(config);
            if (traverseResult) {
                return traverseResult;
            }
            return {
                success: true,
            };
        }
    },
};
const bottomLeftNavValidator = {
    validate(config) {
        const result = validateDirectLeftNavCommon(config);
        if (result) {
            return result;
        }
        if (config.navComponent && config.children) {
            return {
                success: false,
                error: 'navComponent and children not allowed to coexist in bottom left nav'
            };
        }
        if (config.navComponent && typeof config.navComponent !== 'function') {
            return {
                success: false,
                error: 'navComponent must be a function or class/function ReactComponent and required',
            };
        }
        if (Array.isArray(config.children) && config.children.length > 0 && !config.children.every(child => typeof child === 'object' && typeof child.path === 'string')) {
            return {
                success: false,
                error: 'children must be an array of LeftNavItem objects with a path property'
            };
        }
        if (config.mapStateToProps && typeof config.mapStateToProps !== 'function') {
            return {
                success: false,
                error: 'optional mapStateToProps must be a function',
            };
        }
        return {
            success: true,
        };
    }
};
export const SPARKY_NAV3_BOTTOM_LEFT_EXTPOINT = {
    id: 'sparky.nav.v3.left.bottom',
    version: '0.0.1',
    compatibilityRange: '~0.0.1',
    isSingleton: false,
    description: 'merge navigation item to sparky for bottom left nav v3',
    validator: bottomLeftNavValidator,
};
export const SPARKY_NAV3_BOTTOM_MOST_LEFT_EXTPOINT = {
    id: 'sparky.nav.v3.left.bottom.most',
    version: '0.0.1',
    compatibilityRange: '~0.0.1',
    isSingleton: true,
    description: 'set navigation item to sparky for bottom most of left nav v3',
    validator: bottomLeftNavValidator,
};
export const SPARKY_NAV3_DYNAMIC_BOTTOM_LEFT_EXTPOINT = {
    id: 'sparky.nav.v3.dynamic.left.bottom',
    version: '0.0.1',
    compatibilityRange: '~0.0.1',
    isSingleton: false,
    description: 'merge navigation dynamic sub-menu to sparky for bottom left nav v3',
    validator: {
        validate(config) {
            const result = validateDirectLeftNavCommon(config);
            if (result) {
                return result;
            }
            if (config.children) {
                return {
                    success: false,
                    error: 'children are not allowed for dynamic bottom left nav item'
                };
            }
            if (!config.dynamicChildren || typeof config.dynamicChildren !== 'function') {
                return {
                    success: false,
                    error: 'required dynamicChildren must be a function return an array of left nav item'
                };
            }
            if (config.navComponent) {
                return {
                    success: false,
                    error: 'navComponent is not allowed for dynamic left nav item',
                };
            }
            if (config.mapStateToProps) {
                return {
                    success: false,
                    error: 'mapStateToProps is not allowed',
                };
            }
            return {
                success: true,
            };
        }
    },
};
export const SPARKY_TSG_MFE_PROPERTY_FALLBACK_EXTPOINT = {
    id: 'sparky.mfe.prop.tsg.fallback',
    version: '0.0.1',
    compatibilityRange: '~0.0.1',
    isSingleton: false,
    description: 'add fallback fetch for tsg level mfe properties',
    validator: {
        validate(config) {
            if (!config) {
                return {
                    success: false,
                    error: 'mfe property fallback configuration cannot be empty',
                };
            }
            if (!config.key || typeof config.key !== 'string') {
                return {
                    success: false,
                    error: 'key is required and must be a string',
                };
            }
            if (!config.source || typeof config.source !== 'string') {
                return {
                    success: false,
                    error: 'source is required and must be a string',
                };
            }
            if (config.sync != null && typeof config.sync !== 'boolean') {
                return {
                    success: false,
                    error: 'optional sync and must be a boolean',
                };
            }
            if (typeof config.generate !== 'function') {
                return {
                    success: false,
                    error: 'generate is required and must be a function',
                };
            }
            if (!validateIsAllowed(config.isAllowed)) {
                return {
                    success: false,
                    error: 'optional isAllowed must be a function',
                };
            }
            return {
                success: true,
            };
        }
    },
};
export const SPARKY_TSG_MFE_PROPERTY_OVERRIDE_EXTPOINT = {
    id: 'sparky.mfe.prop.tsg.overrides',
    version: '0.0.1',
    compatibilityRange: '~0.0.1',
    isSingleton: false,
    description: 'add overrides mfe properties',
    validator: {
        validate(config) {
            if (!config) {
                return {
                    success: false,
                    error: 'mfe property overrides configuration cannot be empty',
                };
            }
            if (!config.key || typeof config.key !== 'string') {
                return {
                    success: false,
                    error: 'key is required and must be a string',
                };
            }
            if (typeof config.override !== 'function') {
                return {
                    success: false,
                    error: 'override is required and must be a function',
                };
            }
            if (!validateIsAllowed(config.isAllowed)) {
                return {
                    success: false,
                    error: 'optional isAllowed must be a function',
                };
            }
            return {
                success: true,
            };
        }
    },
};
export const SPARKY_NAV3_TSG_STATE_LOADERS_EXTPOINT = {
    id: 'sparky.nav.v3.state.tsg.loaders',
    version: '0.0.1',
    compatibilityRange: '~0.0.1',
    isSingleton: false,
    description: 'add tsg store loaders for left nav v3',
    validator: {
        validate(config) {
            if (!config) {
                return {
                    success: false,
                    error: 'state loader configuration cannot be empty',
                };
            }
            if (!config.name || typeof config.name !== 'string') {
                return {
                    success: false,
                    error: 'name is required and must be a string',
                };
            }
            if (config.requireFetch != null && typeof config.requireFetch !== 'boolean') {
                return {
                    success: false,
                    error: 'optional requireFetch and must be a boolean',
                };
            }
            if (typeof config.loader !== 'function') {
                return {
                    success: false,
                    error: 'loader is required and must be a function',
                };
            }
            if (!validateIsAllowed(config.isAllowed)) {
                return {
                    success: false,
                    error: 'optional isAllowed must be a function',
                };
            }
            return {
                success: true,
            };
        }
    },
};
export const SPARKY_NAV3_TSG_EXPOSES_COMPAT_EXTPOINT = {
    id: 'sparky.nav.v3.tsg.exposes',
    version: '0.0.1',
    compatibilityRange: '~0.0.1',
    isSingleton: false,
    description: 'add tsg level exposes for backward compatible for left nav v3',
    validator: {
        validate(config) {
            if (!config) {
                return {
                    success: false,
                    error: 'exposes configuration cannot be empty',
                };
            }
            if (typeof config.exposes !== 'function') {
                return {
                    success: false,
                    error: 'exposes must be a function and required',
                };
            }
            if (!validateIsAllowed(config.isAllowed)) {
                return {
                    success: false,
                    error: 'optional isAllowed must be a function',
                };
            }
            return {
                success: true,
            };
        }
    }
};
export const SPARKY_SERVICE_URL_PROVIDER_EXTPOINT = {
    id: 'sparky.service_urls.providers',
    version: '0.0.1',
    compatibilityRange: '~0.0.1',
    isSingleton: false,
    description: 'provide name and url value for getServiceUrl method',
    validator: {
        validate(config) {
            if (!config) {
                return {
                    success: false,
                    error: 'service url provider configuration cannot be empty',
                };
            }
            if (!validateIsAllowed(config.isAllowed)) {
                return {
                    success: false,
                    error: 'optional isAllowed must be a function',
                };
            }
            if (config.match != null && !isStringOrStrings(config.match) &&
                !isRegExp(config.match) && typeof config.match !== 'function') {
                return {
                    success: false,
                    error: 'optional match must be a string, array of strings, regular expression, object with prefix property, or a function'
                };
            }
            if (!config.getServiceUrl || typeof config.getServiceUrl !== 'function') {
                return {
                    success: false,
                    error: 'getServiceUrl is required and must be a function',
                };
            }
            if (config.allowFallback != null && typeof config.allowFallback !== 'boolean') {
                return {
                    success: false,
                    error: 'optional allowFallback must be a boolean'
                };
            }
            return {
                success: true,
            };
        }
    }
};
export const SPARKY_FEATURE_FLAG_PROVIDER_EXTPOINT = {
    id: 'sparky.feature_flags.providers',
    version: '0.0.1',
    compatibilityRange: '~0.0.1',
    isSingleton: false,
    description: 'provide name and value for getFeatureFlag method',
    validator: {
        validate(config) {
            if (!config) {
                return {
                    success: false,
                    error: 'feature flag provider configuration cannot be empty',
                };
            }
            if (!validateIsAllowed(config.isAllowed)) {
                return {
                    success: false,
                    error: 'optional isAllowed must be a function',
                };
            }
            if (config.match != null && !isStringOrStrings(config.match) &&
                !isRegExp(config.match) && typeof config.match !== 'function') {
                return {
                    success: false,
                    error: 'optional match must be a string, array of strings, regular expression, object with prefix property, or a function'
                };
            }
            if (!config.fromService || !isStringOrStrings(config.fromService)) {
                return {
                    success: false,
                    error: 'fromService is required and must be a string'
                };
            }
            if (!config.getFeatureFlag || typeof config.getFeatureFlag !== 'function') {
                return {
                    success: false,
                    error: 'getFeatureFlag is required and must be a function',
                };
            }
            if (config.allowFallback != null && typeof config.allowFallback !== 'boolean') {
                return {
                    success: false,
                    error: 'optional allowFallback must be a boolean'
                };
            }
            return {
                success: true,
            };
        }
    }
};
export const initExtensionPoints = [
    SPARKY_LIBS_EXTPOINT,
    SPARKY_SERVICE_URL_PROVIDER_EXTPOINT,
    SPARKY_FEATURE_FLAG_PROVIDER_EXTPOINT,
    SPARKY_MFE_TSG_PREFILTER_EXTPOINT,
    SPARKY_MFE_TSG_VERSION_SELECT_EXTPOINT,
    SPARKY_TSG_MFE_PROPERTY_FALLBACK_EXTPOINT,
];
export const extPointsExports = {
    SPARKY_LIBS_EXTPOINT,
    SPARKY_SERVICE_URL_PROVIDER_EXTPOINT,
    SPARKY_FEATURE_FLAG_PROVIDER_EXTPOINT,
    SPARKY_MFE_TSG_PREFILTER_EXTPOINT,
    SPARKY_MFE_TSG_VERSION_SELECT_EXTPOINT,
    SPARKY_TSG_MFE_PROPERTY_FALLBACK_EXTPOINT,
    SPARKY_NAV2_ROUTES_EXTPOINT,
    SPARKY_NAV3_ROUTES_EXTPOINT,
    SPARKY_NAV3_REDIRECTS_EXTPOINT,
    SPARKY_NAV3_LEFT_NAV_EXTPOINT,
    SPARKY_NAV3_LEFT_NAV_TPL_EXTPOINT,
    SPARKY_NAV3_BOTTOM_LEFT_EXTPOINT,
    SPARKY_NAV3_BOTTOM_MOST_LEFT_EXTPOINT,
    SPARKY_NAV3_DYNAMIC_BOTTOM_LEFT_EXTPOINT,
    SPARKY_NAV3_DYNAMIC_TOP_LEFT_EXTPOINT,
    SPARKY_NAV3_TSG_STATE_LOADERS_EXTPOINT,
    SPARKY_NAV3_TSG_EXPOSES_COMPAT_EXTPOINT,
};
export const extpoints = [
    ...initExtensionPoints,
    SPARKY_NAV2_ROUTES_EXTPOINT,
    SPARKY_NAV3_ROUTES_EXTPOINT,
    SPARKY_NAV3_REDIRECTS_EXTPOINT,
    SPARKY_NAV3_LEFT_NAV_EXTPOINT,
    SPARKY_NAV3_LEFT_NAV_TPL_EXTPOINT,
    SPARKY_NAV3_BOTTOM_LEFT_EXTPOINT,
    SPARKY_NAV3_BOTTOM_MOST_LEFT_EXTPOINT,
    SPARKY_NAV3_DYNAMIC_BOTTOM_LEFT_EXTPOINT,
    SPARKY_NAV3_DYNAMIC_TOP_LEFT_EXTPOINT,
    SPARKY_NAV3_TSG_STATE_LOADERS_EXTPOINT,
    SPARKY_NAV3_TSG_EXPOSES_COMPAT_EXTPOINT,
];
export default extpoints; // move object.assign to exports avoid side effect
